import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export default function PropertiesSection() {
    const { t, i18n } = useTranslation();
    const [countries, setCountries] = useState([]);

    useEffect(() => {
        fetch("https://ligasos-laravel.ligasos.co/api/countries")
            .then((response) => response.json())
            .then((data) => setCountries(data))
            .catch((error) => console.error("Error fetching countries:", error));
    }, []);

    const isArabic = i18n.language === "ar";

    const showData = countries.map((country) => (
        <Link
            key={country.id}
            to={`propertiesPlaces/${encodeURIComponent(isArabic ? country.name_ar : country.name_en)}`}
            className="w-165-px g-5rem p-respons w-[210px] px-5 py-[1rem] flex items-center gap-4 border border-[#D9D9D9] rounded-[8px]"
        >
            <div>
                <img
                    className="w-respons w-[50px] h-[50px] rounded-full"
                    src={`https://ligasos-laravel.ligasos.co/storage/app/public/${country.image}`}
                    alt={`country-${country.id}`}
                />
            </div>
            <div>
                <div className="text-[#0B2C3D] font-bold capitalize">
                    {t(isArabic ? country.name_ar : country.name_en)}
                </div>
                <div className="flex items-center gap-[3px]">
                    <span>{country.properties_count}</span>
                    {t("Properties")}
                </div>
            </div>
        </Link>
    ));

    return (
        <section className="relative py-[40px]">
            <div className="main-title">
                <div className="js-scroll fade-btm secund">{t("Explore properties")}</div>
            </div>
            <div className="container py-[20px] flex-col gap-[20px]">
                <div className="just-center flex flex-wrap items-center justify-center gap-[10px]">
                    {showData}
                </div>
            </div>
        </section>
    );
}